/* eslint-disable custom/to-have-test-file -- Ide nem kell teszt. */

import { baseGlobals } from '@root/typescript/baseGlobals'

if (baseGlobals.isDev) {
  import(
    /* webpackChunkName: "onError" */
    '@common/onError/client/listenErrors'
  ).then(({ default: listenErrors }) => listenErrors())
}
